import request from "axios";
import {getApiHost} from "../config";

export const joinContest = async ({id, name}: {
  id: string,
  name: string
}): Promise<void> => {
  return (await request.post(getApiHost() + `/predictions/contests/${id}/join`, {name}, {withCredentials: true}));
}

export interface ContestSummaryResponse {
  id: string,
  name: string,
  description: string,
  createdAt: string,
  isOpen: boolean,
  isParticipant: boolean,
  predictionCount: number,
}

export interface ContestSummaryListResponse {
  contests: ContestSummaryResponse[],
}

export const fetchPublicContests = async (): Promise<ContestSummaryListResponse> => {
  return (await request.get(getApiHost() + "/predictions/public/contests")).data;
}

export const fetchContests = async (): Promise<ContestSummaryListResponse> => {
  return (await request.get(getApiHost() + "/predictions/contests", {withCredentials: true})).data;
}

export interface ContestDetailPredictionResponse {
  ordinal: number,
  text: string,
  details: string,
  defaultValue: number,
  value: number,
  outcome?: 'true' | 'false' | 'none'
  outcomeText?: string
  score?: number,
  expectedResolution: string
}

export interface ContestDetailResponse {
  id: string,
  name: string,
  description: string,
  instructions: string,
  createdAt: string,
  isOpen: boolean,
  submissionDeadline: string,
  isParticipant: boolean,
  participantName: string,
  participantPosition: number,
  predictionCount: number,
  predictions: ContestDetailPredictionResponse[]
}

export const fetchContest = async ({id}: { id: string }): Promise<ContestDetailResponse> => {
  return (await request.get(getApiHost() + `/predictions/contests/${id}`, {withCredentials: true})).data;
}

export interface PredictionResponses {
  responses: {
    participantName: string
    value: number
    score?: number
  }[]
}

export const fetchPredictionResponses = async ({contestId, predictionOrdinal}: {
  contestId: string,
  predictionOrdinal: number
}): Promise<PredictionResponses> => {
  return (await request.get(getApiHost() + `/predictions/contests/${contestId}/predictions/${predictionOrdinal}/responses`, {withCredentials: true})).data;
}

export interface ContestLeaderboardResponse {
  leaderboard: {
    position: number
    participantName: string
    score: number
  }[]
}

export const fetchLeaderboard = async ({contestId}: {
  contestId: string,
}): Promise<ContestLeaderboardResponse> => {
  return (await request.get(getApiHost() + `/predictions/contests/${contestId}/leaderboard`, {withCredentials: true})).data;
}

export interface PredictionResponsesRequest {
  [ordinal: number]: number
}

export const updatePredictions = async ({id, predictionResponses}: {
  id: string,
  predictionResponses: PredictionResponsesRequest
}): Promise<ContestDetailResponse> => {
  return (await request.put(getApiHost() + `/predictions/contests/${id}/predictions`, {responses: predictionResponses}, {withCredentials: true})).data;
}
